import Phaser from 'phaser';
import { MainScene } from './scenes/MainScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 400,
  height: 600,
  backgroundColor: '#4EC0CA',
  parent: document.body,
  scene: [MainScene],
};

new Phaser.Game(config);
